import { RouterProvider } from "react-router-dom";
import "./styles/index.css";
import "./styles/fonts.css";
import router from "./router/router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { Loader } from "./components/loader/Loader";
import { useLoader } from "./store/useLoader";

function App() {
  const queryClient = new QueryClient();
  const { activeLoader } = useLoader();
  return (
    <div className="mro-fotos-componentes">
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 5000,
            style: {
              background: "transparent",
              boxShadow: "none",
              padding: 0,
            },
          }}
        />
        {activeLoader ? <Loader full fullScreen /> : null}
      </QueryClientProvider>
    </div>
  );
}

export default App;
